import React from 'react';
import { Routes, Route } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';
import usePersistStoreData from '../Components/Hooks/usePersistStoreData';
import RiskDisclosure from '../pages/RiskDisclosure';

const Index = () => {
    const { userData } = usePersistStoreData();
  const token = userData?.token;
    return (
        <React.Fragment>
            <Routes>
                {/* Public Routes */}
                {publicRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <NonAuthLayout>
                                {route.component}
                            </NonAuthLayout>
                        }
                        key={idx}
                        exact={true}
                    />
                ))}

                {/* Risk Disclosures - Accessible to both */}
                <Route
                    path="/risk-disclosures"
                    element={
                        token ? (
                            <VerticalLayout>
                                <RiskDisclosure />
                            </VerticalLayout>
                        ) : (
                            <NonAuthLayout>
                                <RiskDisclosure />
                            </NonAuthLayout>
                        )
                    }
                />

                {/* Protected Routes */}
                {token && authProtectedRoutes.map((route, idx) => (
                    <Route
                        path={route.path}
                        element={
                            <AuthProtected>
                                <VerticalLayout>{route.component}</VerticalLayout>
                            </AuthProtected>
                        }
                        key={idx}
                        exact={true}
                    />
                ))}
            </Routes>
        </React.Fragment>
    );
};

export default Index;